import { skillRepo } from "@repositories";
import { type Skill } from "@entities";
import clsx from "clsx";
import { useEffect, useState, type FC } from "react";
import { GenericCheckbox } from "../three-checkbox/GenericCheckbox";
import { TwoCheckbox } from "../two-checkbox/TwoCheckbox";
import "./Skills.scss";

interface SkillsProps {
  handleSave: (skills: string[], hasVehicle: boolean) => void;
  chosenSkills: string[];
  hasVehicle: boolean;
  isProfile?: boolean;
}

export const Skills: FC<SkillsProps> = ({ handleSave, chosenSkills, hasVehicle: isVehicle, isProfile }) => {
  const [skills, setSkills] = useState<Skill[]>();
  const [selectedSkills, setSelectedSkills] = useState<string[]>([]);
  const [hasVehicle, setHasVehicle] = useState<boolean>(isVehicle);

  useEffect(() => {
    getSkills();
  }, []);

  async function getSkills() {
    const result = await skillRepo.find();
    setSkills(result);
    setSelectedSkills(chosenSkills);
  }

  return (
    <div className="skills-container">
      <div className="skills-section physical-skills">
        <GenericCheckbox
          buttons={
            skills
              ?.filter((skill) => skill.type === "physical")
              .map((skill) => ({ label: skill.name, name: skill.id })) || []
          }
          handleChange={(event) => {
            setSelectedSkills((prev) => {
              if (prev.includes(event.target.name))
                return prev.filter((skillId) => skillId !== event.target.name);
              else return [...prev, event.target.name];
            });
          }}
          text="כשירות פיזית"
          value={selectedSkills}
        />
      </div>

      <div className="skills-section language-skills">
        <GenericCheckbox
          buttons={
            skills
              ?.filter((skill) => skill.type === "languages")
              .map((skill) => ({ label: skill.name, name: skill.id })) || []
          }
          handleChange={(event) => {
            setSelectedSkills((prev) => {
              if (prev.includes(event.target.name))
                return prev.filter((skillId) => skillId !== event.target.name);
              else return [...prev, event.target.name];
            });
          }}
          text="שפות"
          value={selectedSkills}
        />
      </div>

      <div className="skills-section vehicle-section">
        <TwoCheckbox
          labelClassName="vehicle-checkbox-label"
          text={isProfile ? "יש רכב" : "נדרש רכב"}
          isChecked={hasVehicle}
          handleChange={(event) => {
            setHasVehicle(event.target.name === "yes" ? true : false);
          }}
        />
      </div>

      <div className="skills-section profession-skills">
        <h3 className="section-title">מקצועות / תחומי עניין</h3>
        <div className="profession-buttons">
          {skills
            ?.filter((skill) => skill.type === "profession")
            .map((skill) => {
              return (
                <button
                  className={clsx(
                    "skill-button",
                    selectedSkills.includes(skill.id) && "selected",
                  )}
                  key={skill.id}
                  onClick={() => {
                    setSelectedSkills((prev) => {
                      if (prev.includes(skill.id))
                        return prev.filter((skillId) => skillId !== skill.id);
                      else return [...prev, skill.id];
                    });
                  }}
                >
                  <span>{skill.name}</span>
                </button>
              );
            })}
        </div>
      </div>

      <div className="action-section">
        <button
          className="save-button"
          onClick={() => handleSave(selectedSkills, hasVehicle)}
        >
          שמירה
        </button>
      </div>
    </div>
  );
};
